import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@arcadeai/design-system/components/ui/atoms/dialog";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@arcadeai/design-system/components/ui/atoms/tooltip";
import { cn } from "@arcadeai/design-system/lib/utils";
import { Loader2, Trash } from "lucide-react";
import { useState } from "react";

type DeleteDialogProps = {
  title: string;
  description: string;
  isLoading?: boolean;
  onDelete?: () => void;
  tooltipText?: string;
  className?: string;
};

export const DeleteDialog = ({
  title,
  description,
  isLoading,
  onDelete,
  tooltipText = "Delete",
  className,
}: DeleteDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <TooltipProvider delay={200}>
        <Tooltip>
          <TooltipTrigger
            render={
              <Button
                className={cn("mr-2 text-destructive/70", className)}
                disabled={isLoading}
                onClick={() => setOpen(true)}
                size="sm"
                variant="ghost"
              />
            }
          >
            {isLoading ? (
              <Loader2 className="size-4 animate-spin" />
            ) : (
              <Trash className="size-4" />
            )}
          </TooltipTrigger>
          <TooltipContent>
            <p>{tooltipText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="mb-2">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="mt-2 flex justify-end gap-2">
          <Button onClick={() => setOpen(false)} size="sm" variant="outline">
            Cancel
          </Button>
          <Button
            disabled={isLoading}
            onClick={() => {
              onDelete?.();
              setOpen(false);
            }}
            size="sm"
            variant="destructive"
          >
            {isLoading ? <Loader2 className="size-4 animate-spin" /> : "Delete"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
